import React from 'react'
import Layouts from '../../Layouts/Layouts'
import { StyledMainPageRightSection } from '../dashboard/style.dashboard'

const PassportServices = () => {
  return (
    <>
      <Layouts>

        <StyledMainPageRightSection>
        <h1>ON Passport services</h1>
        </StyledMainPageRightSection>
      </Layouts>
      
    </>
  )
}

export default PassportServices
